export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, function (txt) {
    return (
      txt.charAt(0).toUpperCase() +
      txt.substr(1).toLowerCase()
    );
  });
};

export const extractAgripixPath = (url: string): string => {
  let pathname: string;
  try {
    const urlObj = new URL(url);
    pathname = urlObj.pathname;
  } catch {
    pathname = url.split('?')[0];
  }

  const parts = pathname.split('/').filter(Boolean);
  const agripixIndex = parts.indexOf('agripix');

  if (agripixIndex === -1) return '';

  const folder = parts[agripixIndex + 3];
  const file = parts[agripixIndex + 4];

  if (!folder || !file) return '';

  return `agripix/${folder}/${file}`;
};
